import { h } from "preact";
import { Text } from "../../../components/text";
import { IColumnData } from "../interfaces/table";
import moment from "moment";

export const COULMN_DATA = (): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceID",
    key: "deviceID",
    width: "10em",
    render: (text) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  },
  {
    title: "หมายเลขรหัส PL",
    dataIndex: "deviceLotID",
    key: "deviceLotID",
    width: "10em",
  },
  {
    title: "รหัส SO",
    dataIndex: "soId",
    key: "soId",
    width: "10em",
  },
  {
    title: "รหัส Invoice",
    dataIndex: "invoiceId",
    key: "invoiceId",
    width: "12em",
  },
  {
    title: "วันที่ Invoice",
    dataIndex: "invoiceDate",
    key: "invoiceDate",
    width: "8em",
    render: (text: any) => {
      if (!text) return <Text size={"S"} text={"-"} />;
      return <Text size={"S"} text={moment(text).format("YYYY-MM-DD")} />;
    },
  },
  {
    title: "Lot/เดือน",
    dataIndex: "lotMonth",
    key: "lotMonth",
    width: "8em",
    render: (text: any) => {
      if (!text) return <Text size={"S"} text={"-"} />;
      return <Text size={"S"} text={text} />;
    },
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "customerCode",
    key: "customerCode",
    width: "10em",
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "customerName",
    key: "customerName",
    width: "16em",
    align: "left",
  },
  {
    title: "ลักษณะเครื่อง",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "14em",
  },
  {
    title: "ขนาดเครื่อง",
    dataIndex: "deviceSize",
    key: "deviceSize",
    width: "10em",
  },
];
